import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLock, faLockOpen} from "@fortawesome/free-solid-svg-icons";
import '../compare/compare.scss'
import {t} from "i18next";

const LockCompetitor = ({isLocked, toggleLock, vehicle,vehicleIndex,trimCodes}) => {

    function checkLockStatus(vehicle, isLockedData) {
        const hasDuplicates = trimCodes?.filter(code => code === vehicle?.code).length > 1;
        const lockKey = vehicle?.code;
        if (hasDuplicates) {
            if (isLockedData[lockKey]) {
                return isLockedData[lockKey].some(entry => entry.vehicleIndex === vehicleIndex && entry.lockStatus);
            }
        } else {
            if (isLockedData[lockKey]) {
                return Boolean(isLockedData[lockKey][0]?.lockStatus);
            }
        }
        return false;
    }

    return (

        <React.Fragment>
            {vehicle && <div
                className={`lock-icon-wrapper ${checkLockStatus(vehicle, isLocked) ? "lock-icon" : "unlock-icon"}`}
                onClick={toggleLock}
            >
                <div className={"icon-wrapper-transition"}>
                    <div className="tooltip-lock">
                        {checkLockStatus(vehicle, isLocked) ? t('overview.controls.lock') : t('overview.controls.unlock')}
                    </div>
                    <FontAwesomeIcon icon={checkLockStatus(vehicle, isLocked) ? faLock : faLockOpen}/>
                </div>
            </div>}
        </React.Fragment>

    )

}

export default LockCompetitor;
